/**
 * YUMO yatay kaydırma eksen kilidi.
 * Parmak hareketi yatay yönde baskınsa dikey sayfa kaymasını engeller;
 * dikey baskınsa carousel'e hiç dokunmaz. Bırakınca en yakın karta
 * (veya fiske yönündeki karta) yumuşakça oturur.
 */
(function () {
  var SELECTOR =
    '.yumo-showcase__track, .yumo-discovery__grid, .yumo-categories__grid, .yumo-gallery__masonry, .yumo-contents__tiles';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll(SELECTOR).forEach(function (el) {
    var centerSnap = el.classList.contains('yumo-showcase__track');
    var startX = 0;
    var startY = 0;
    var startScroll = 0;
    var lastX = 0;
    var velocity = 0;
    var axis = null;
    var active = false;

    function children() {
      return Array.prototype.filter.call(el.children, function (c) {
        return c.offsetWidth > 0;
      });
    }

    function settle() {
      var kids = children();
      if (!kids.length) return finish();

      var current = el.scrollLeft;
      var target = null;
      var bestD = Infinity;

      kids.forEach(function (kid) {
        var pos = centerSnap
          ? kid.offsetLeft - (el.clientWidth - kid.offsetWidth) / 2
          : kid.offsetLeft;
        var d = Math.abs(pos - current);
        if (d < bestD) {
          bestD = d;
          target = { kid: kid, pos: pos, idx: kids.indexOf(kid) };
        }
      });

      /* Fiske: hız belirginse bir kart ileri/geri */
      if (target && Math.abs(velocity) > 0.4) {
        var idx = Math.min(
          kids.length - 1,
          Math.max(0, target.idx + (velocity < 0 ? 1 : -1))
        );
        var kid = kids[idx];
        target = {
          pos: centerSnap
            ? kid.offsetLeft - (el.clientWidth - kid.offsetWidth) / 2
            : kid.offsetLeft
        };
      }

      if (target) {
        el.scrollTo({ left: target.pos, behavior: reduced ? 'auto' : 'smooth' });
      }
      setTimeout(finish, reduced ? 0 : 320);
    }

    function finish() {
      el.classList.remove('yumo-hlock');
    }

    el.addEventListener(
      'touchstart',
      function (e) {
        if (e.touches.length !== 1) return;
        active = true;
        axis = null;
        velocity = 0;
        startX = lastX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        startScroll = el.scrollLeft;
      },
      { passive: true }
    );

    el.addEventListener(
      'touchmove',
      function (e) {
        if (!active) return;
        var x = e.touches[0].clientX;
        var y = e.touches[0].clientY;
        var dx = x - startX;
        var dy = y - startY;

        if (!axis) {
          if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
          axis = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
          if (axis === 'h') el.classList.add('yumo-hlock');
        }

        if (axis === 'h') {
          /* Dikey sayfa kaymasını tamamen engelle, yatayı elle sür */
          e.preventDefault();
          velocity = x - lastX;
          lastX = x;
          el.scrollLeft = startScroll - dx;
        }
      },
      { passive: false }
    );

    ['touchend', 'touchcancel'].forEach(function (evt) {
      el.addEventListener(
        evt,
        function () {
          if (!active) return;
          active = false;
          if (axis === 'h') settle();
          axis = null;
        },
        { passive: true }
      );
    });
  });
})();

/**
 * Mobil menü: sayfa içi çapa linklerine tıklanınca menüyü kapat.
 * (Aynı sayfada kalındığı için tarayıcı navigasyonu tetiklenmez ve
 * Horizon'un drawer'ı açık kalır — burada elle kapatıyoruz.)
 */
(function () {
  document.addEventListener('click', function (e) {
    if (!(e.target instanceof Element)) return;
    var link = e.target.closest('header-drawer a[href*="#"]');
    if (!link) return;

    var url = new URL(link.href, window.location.href);
    var samePage =
      url.pathname === window.location.pathname && url.hash.length > 1;
    if (!samePage) return;

    var drawer = link.closest('header-drawer');
    if (drawer && typeof drawer.close === 'function') {
      /* Kapanma animasyonu scroll'u bozmasın diye bir tık geciktir */
      requestAnimationFrame(function () {
        drawer.close();
      });
    }
  });
})();
